<template>
  <!--pages/user/index.wxml-->
<div class="page">
    <div class="my-page">
        <div class="my-bg"></div>
        <div class="my-container">
            <div class="my-info">
                <img class="user-pic" src="../assets/images/avatar.jpg" />
                <div class="info-wrap">
                    <div class="nick-name">
                        <span>{{username}}</span>
                    </div>
                    <div class="plus-level">
                        <span>银牌会员</span>
                    </div>
                </div>
                <!-- <img bindtap="logout" class="logout-pic" src="/static/imgs/icon/logout.png" mode=""/> -->
                <div>
                    <!-- <span bindtap="goLogin" class="login-txt">退出</span> -->
                </div>
            </div>
            <div class="mem-level">
                <div class="level-wrap">
                    <span>本月等级：</span>
                    <span class="level">v1</span>
                </div>
                <div class="status-wrap">
                    <span>账户状态：</span>
                    <span>健康</span>
                </div>
            </div>
            <!-- 卡片-->
            <!-- 营销工具-->
            <div class="my-card">
                <div class="my-card-head">营销工具</div>
                <div class="my-card-content">
                    <div class="my-card-tr">
                        <div class="my-card-col" v-if="loginType === 'up'">
                            <div class="img-wrap" @click="goZhuanLian">
                                <hkj-svg iconName="icon-tiaozhuanlianjie2"></hkj-svg>
                                <!-- <img src="../assets/images/icon/link.png" mode="" /> -->
                            </div>
                            <div class="title-wrap">
                                <span class="title">转链</span>
                            </div>
                        </div>
                        <div class="my-card-col">
                            <div class="img-wrap" @click="goOrderSearch">
                                <hkj-svg iconName="icon-order_query"></hkj-svg>
                                <!-- <img src="../assets/images/icon/order.png" mode="" /> -->
                            </div>
                            <div class="title-wrap">
                                <span class="title">订单实时查询</span>
                            </div>
                        </div>
                        <div class="my-card-col">
                            <div class="img-wrap" @click="getCode">
                                <!-- <img src="/assets/images/icon/code.png" mode="" /> -->
                                <hkj-svg iconName="icon-huoquyaoqingma"></hkj-svg>
                            </div>
                            <div class="title-wrap">
                                <span class="title">获取邀请码</span>
                            </div>
                        </div>
                        <div class="my-card-col">

                        </div>
                    </div>
                </div>
            </div>
            <!-- 自助工具-->
            <div class="my-card">
                <div class="my-card-head">自助工具</div>
                <!-- <div class="my-card-content">
                    <div class="my-card-tr">
                        <div class="my-card-col">
                            <div class="img-wrap" bind:tap="goPublic">
                                <img src="/static/imgs/icon/f.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">关注公众号</span>
                            </div>
                        </div>
                        <div class="my-card-col">
                            <div class="img-wrap" bind:tap="goKefu">
                                <img src="/static/imgs/icon/kefu.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">联系客服</span>
                            </div>
                        </div>
                        <div class="my-card-col">
                            <div class="img-wrap" bind:tap="goYijian">
                                <img src="/static/imgs/icon/yijianfankui.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">意见反馈</span>
                            </div>
                        </div>
                        <div class="my-card-col">
                            <div class="img-wrap" bind:tap="goQun">
                                <img src="/static/imgs/icon/vip.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">加入交流群</span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="my-card-content">
                    <div class="my-card-tr">
                        <!-- <div class="my-card-col">
                            <div class="img-wrap" bind:tap="handleSub">
                                <img src="../assets/images/sub.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">订单取消通知</span>
                            </div>
                            <div class="img-wrap" bind:tap="goAbout">
                                <img src="/static/imgs/icon/about.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">关于我们</span>
                            </div>
                        </div> -->
                        <div class="my-card-col">
                            <div class="img-wrap" @click="logout">
                                <hkj-svg iconName="icon-tuichu2"></hkj-svg>
                                <!-- <img @click="logout" src="../assets/images/icon/logout.png" mode="" /> -->
                            </div>
                            <div class="title-wrap">
                                <span class="title">退出登录</span>
                            </div>
                        </div>
                        <div class="my-card-col">
                            <!-- <div class="img-wrap" bind:tap="goHelp">
                                <img src="/static/imgs/icon/help.png" mode="" />
                            </div>
                            <div class="title-wrap">
                                <span class="title">帮助中心</span>
                            </div> -->
                        </div>
                        
                        <div class="my-card-col"></div>
                    </div>
                </div>
            </div>
            <!-- <div class="logout-action-wrap">
                <div class="logout-btn" bindtap="logout">
                    <img src="/static/imgs/icon/logout.png" mode="" />
                    <span>退出登录</span>
                </div>
            </div> -->
            <div class="copyright">
                <span>苏ICP备2024142358号 Copyright © 2024 by 荟客家</span>
            </div>
        </div>
    </div>
    <div class="mask" v-if="showMask">
        <div class="dialog">
            <div class="head">邀请码</div>
            <div class="body">{{ inviteCode }}</div>
            <div class="footer">
                <!-- <button @click="handleCopyCode()">复制</button> -->
                <a href="javascript:" role="button" class="weui-btn wd-auto" @click="handleCopyCode">复制</a>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { logout, getInviteCode } from '@/services/user';
import { loginStore } from '@/store';
import { setToken } from '@/utils/token';
import HkjSvg from '@/components/svg/index.vue';

// logout
export default {
  components: {
    HkjSvg
  },
  data() {
    return {
      username: '',
      // code: '',
      subscribed: '',
      templateId: [],
      inviteCode: '',
      showMask: false,
      loginType: ''
    }
  },
  created() {
    this.username = loginStore.get().username //wx.getStorageSync('username')
    // this.setData({
    //     username: this.data.username
    // })
    // let self = this
    // this.data.subscribed = wx.getStorageSync('subscribed')
    // this.data.templateId = wx.getStorageSync('templateId') || []
    this.loginType = loginStore.getLoginType()

  },
  methods: {
    goZhuanLian() {
      this.$router.push('/coupon/custom')
    },
    goOrderSearch() {
        window.open('https://h5.hkj168.com/order.html', '_blank')      
      //this.$router.push('/search')
    },
    getCode() {
        getInviteCode().then(res => {
            this.showMask = true
            this.inviteCode = res.data.invite_code
        }).catch(() => {
            this.showMask = false
            this.$showToast({
                type: 'icon',
                toastSuccess: false,
                toastMessage: '获取邀请码失败!',
                duration: 1000 
            })
        })
        // Message
    },
    goMyTeam() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    goPublic() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    goKefu() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    goYijian() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    goQun() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    goAbout() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    goHelp() {
        this.$showToast({
            type: 'text',
            toastMessage: '功能开发中，敬请期待！',
            duration: 2000 
        })
    },
    logout() {
        logout().then(() => {
          setToken('')
          this.$router.push('/login')
        }).catch(() => {
            this.$showToast({
                type: 'icon',
                toastSuccess: false,
                toastMessage: '退出登录失败！',
                duration: 2000 
            })
        })
    },
    handleSub() {
    },
    handleCopyCode() {
        navigator.clipboard.writeText(this.inviteCode).then(() => {
        this.$showToast({
            type: 'icon',
            toastSuccess: true,
            toastMessage: '复制成功！',
            duration: 3000 
        })
        this.showMask = false
      }).catch(() => {
        this.$showToast({
            type: 'icon',
            toastSuccess: true,
            toastMessage: '复制失败！',
            duration: 3000 
        })
        this.showMask = false
      })
    }
    
  } 
}
</script>
<style scoped>
/* pages/user/index.wxss */
/**我的页面样式*/
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
    background: rgba(255,255,255, 0.3);
    /* opacity: 0.5; */
}
.mask .dialog {
    width: var(--len250);
    height: var(--len200);
    border: 1px solid orange;
    position: relative;
    background: white;
    margin: 50px auto;
}
.mask .dialog .head{
    border-bottom: 1px solid orange;
    height: 30px;
    line-height: 30px;
    text-indent: 20px;
}
.mask .dialog .footer a{
    color: orange;
}
.mask .dialog .body{
     height: 100px;
    justify-content: center;
    align-items: center;
    display: flex
;
}
.my-page {
    position: relative;
    height: 100vh;
}

.my-bg {
    width: 100%;
    height: var(--len130);
    background: var(--primary-color);
    position: absolute;
    top: 0;
    left: 0;
}

.my-container {
    padding: var(--len10) var(--len10) 0px var(--len10);
    position: relative;
    top: 0;
    box-sizing: border-box;
    z-index: 1;
}

.my-info {
    position: relative;
    font-size: var(--len18);
    display: flex;
    align-items: center;
}

.my-info .user-pic {
    width: var(--len80);
    height: var(--len80);
    border-radius: var(--len80);
    border: 2px solid white;
}

.logout-pic {
    margin-left: var(--len20);
    width: var(--len30);
    height: var(--len30);
}

.info-wrap {
    /* flex: 1; */
    margin-left: var(--len20);
}

.plus-level {
    color: black;
    background-color: white;
    border-radius: var(--len20);
    height: var(--len20);
    line-height: var(--len20);
    width: var(--len70);
    text-align: center;
    font-size: var(--len12);
}

/** 会员等级 */
.my-plus {
    border: 2px solid rgba(255, 128, 0, 0.3);
    border-radius: var(--len10);
    display: flex;
    width: 100%;
    height: var(--len60);
    margin-top: var(--len10);
    padding: var(--len10);
    box-sizing: border-box;
    align-items: center;
    color: var(--black-color);
}

.grid {
    flex: 1;
    text-align: center;
    border-right: 0.5px solid rgba(0, 0, 0, 0.1);
    font-size: var(--len12);
}

.grid3 {
    border-right: 0;
}

.login-txt {
    font-size: var(--len18);
    color: white;
    font-weight: bold;
}

.nick-name {
    color: white;
}

/** 会员等级 */
.mem-level {
    margin-top: var(--len16);
    height: var(--len40);
    background-color: var(--primary-color-h);
    opacity: 0.5;
    border-radius: var(--len5);
    color: white;
    font-size: var(--len12);
    display: flex;
    align-items: center;
    /* justify-content: center; */
}

.level-wrap,
.status-wrap {
    flex: 1;
    margin-left: var(--len16);
}

.level {
    background-color: white;
    width: var(--len40);
    height: var(--len14);
    line-height: var(--len14);
    border-radius: var(--len12);
    color: var(--primary-color);
    display: inline-block;
    text-align: center;
}
</style>